var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","small":"","color":"error","min-width":"115"},on:{"click":function($event){return _vm.removerAnexo()}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"size":"17"}},[_vm._v("mdi-delete")]),_vm._v(" Remover")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }